import { createFileRoute } from '@tanstack/react-router';

import UserCertifications from '@/ui/pages/UserCertifications/UserCertifications';

export const Route = createFileRoute('/_dashboard/users/$id/$tenantId/certifications')({
  component: UserCertifications,
});
